import swal from "sweetalert";

const queryArr = [
    "''",
    "--",
    "*",
    "select *",
    "/*",
    "*/",
    "@@",
    "char",
    "nchar",
    "varchar",
    "nvarchar",
    "select",
    "insert",
    "update",
    "delete",
    "from",
    "table",
    "drop",
    "create",
    "alter",
    "begin",
    "end",
    "grant",
    "deny",
    "exec",
    "sp_",
    "xp_",
    "cursor",
    "fetch",
    "kill",
    "open",
    "sysobjects",
    "syscolumns",
    "sys",
  ];

export const PreventSqlInjection=(inputValue)=>{ 

  
  let flag=false;  
    for (let i = 0; i < queryArr.length; i++) {
        if (inputValue.includes(queryArr[i])) {
          flag = true;
          return flag;
        }else{
          flag = false;
        }
      }
      
        return flag;
        
    
}

